export const GET_ALL_ROLE_COMBOBOX = `
query GetRoleComboBox ($input: TroleWhereInput) {
    getRole (where: $input ) {
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items {
            id
            name
        }
    }
}`;
export const GET_ALL_ROLE_BY_FILTER = `query GetRole ($input: TroleWhereInput, $skip: Float, $take: Float) {
    getRole (where: $input, skip: $skip, take: $take ) {
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items {
            id
            name
            note
        }
    }
}`;
